module.exports = __webpack_public_path__ + "img/contentImg3.06b40727.png";